import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BulkFormalizeComponent } from './bulk-formalize.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [BulkFormalizeComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [BulkFormalizeComponent],
  entryComponents: [BulkFormalizeComponent]
})
export class BulkFormalizeModule { }
